const removeDispatchMapping = (dispatch) => ({
    // We don't need this event any more, because currently the comparing page is an independent page not inside the results page as well.
    // toggleCompare: (toggle) => {
    //     dispatch({
    //         type: 'TOGGLE_COMPARE_MODE',
    //         toggle
    //     });
    // },
    removeProduct: (productId) => {
        dispatch({
            type: 'TOGGLE_COMPARED_PRODUCT',
            toggle: false,
            filterValue: productId
        });
    }
});

export { removeDispatchMapping };
